import {isMobile, isEditor} from '../../../../commons/selectors/environment'
import {getListLayout, isSingleEventWidget} from '../../../../commons/selectors/settings'
import {isEmptyStateNotificationVisible} from '../../selectors/list-settings'
import {getComponentConfig} from '../../selectors/settings'
import {AppProps} from '../app/interfaces'
import {connect} from '../runtime-context/connect'
import {Layout as Presentation} from './layout'
import {LayoutStateProps, LayoutOwnProps} from './interfaces'

const mapRuntime = ({state}: AppProps): LayoutStateProps => ({
  listLayout: getListLayout(getComponentConfig(state)),
  singleEventWidget: isSingleEventWidget(getComponentConfig(state)),
  emptyStateVisible: isEmptyStateNotificationVisible(state),
  mobile: isMobile(state),
  editor: isEditor(state),
})

export const Layout = connect<LayoutOwnProps, LayoutStateProps>(mapRuntime)(Presentation)
export * from './interfaces'
